/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import React, { Fragment, useState } from 'react'

import { EuiButtonEmpty } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import { withErrorBoundary } from '@modules/cui/Boundary'
import useOrganization from '@modules/billing-lib/hooks/useOrganization'

import ConvertOrganizationFlyout from './ConvertOrganizationFlyout'
import { messages } from './messages'

import type { ConvertOrganizationButtonProps } from './types'
import type { FunctionComponent } from 'react'

const ConvertOrganizationButton: FunctionComponent<ConvertOrganizationButtonProps> = ({
  email,
}) => {
  const [modalOpen, setModalOpen] = useState(false)
  const orgQuery = useOrganization()

  if (!orgQuery.data) {
    return null
  }

  const organizationId = orgQuery.data.organization.organization_id
  const isPaying = orgQuery.data.subscription.is_paying
  const conversionType = isPaying ? 'deactivate' : 'activate'

  const convertMessage = {
    activate: messages.activateOrganization,
    deactivate: messages.deactivateOrganization,
  }[conversionType]

  return (
    <Fragment>
      <EuiButtonEmpty size='s' onClick={() => setModalOpen(true)}>
        <FormattedMessage {...convertMessage} />
      </EuiButtonEmpty>

      {modalOpen && (
        <ConvertOrganizationFlyout
          conversionType={conversionType}
          organizationId={organizationId}
          email={email}
          onClose={() => setModalOpen(false)}
        />
      )}
    </Fragment>
  )
}

export default withErrorBoundary(ConvertOrganizationButton)
